import React from 'react';
import PropTypes from 'prop-types';

import styled from 'styled-components';
import { ZIcon, ZInfoBox } from '@zanichelli/albe-web-components/react';

import Tooltip from '../tooltip';

const ClosedBoxContainer = styled.div`
    position: relative;

    width: fit-content;
    height: fit-content;

    &:hover > .TooltipWrapper {
        display: block;
    }

    .TooltipWrapper {
        display: none;
    }
`;

export const ClosedBox = styled.button`
    border-radius: var(--border-radius);
    border: none;
    background-color: var(--blue50);
    color: var(--gray800);

    padding: calc(var(--space-unit) * 2);
    position: relative;
    cursor: pointer;

    &:hover {
        box-shadow: var(--shadow-1);
        outline: none;
    }

    &:focus {
        box-shadow: var(--outline);
        outline: none;
    }
`;

const ClosedBoxTooltip = styled(Tooltip)`
    white-space: nowrap;
    color: var(--color-white);

    font-size: 12px;
    letter-spacing: 0.32px;
    line-height: 16px;

    top: 9px;
`;

const InfoBoxContent = styled.div`
    display: flex;
    width: 100%;
`;

const BulbIcon = styled(ZIcon)`
    vertical-align: top;
    margin-right: calc(var(--space-unit) / 2);
`;

const InfoBoxTitleBody = styled.span`
    margin-right: calc(var(--space-unit) / 2);
`;

const InfoBoxTitle = () => <InfoBoxTitleBody className="body-5-sb">{'Come si fa?'}</InfoBoxTitleBody>;

const HintBox = ({ label, isOpen, exerciseType, toggleHintBox }) => {
    return (
        <>
            {isOpen ? (
                <ZInfoBox boxid="hint-box" isclosable={true} onInfoBoxClose={() => toggleHintBox(exerciseType)}>
                    <InfoBoxContent slot="content">
                        <BulbIcon name="electric-light-bulb" fill="surface-grey-800" width="14" height="14" />
                        <span className="body-5">
                            <InfoBoxTitle />
                            {label}
                        </span>
                    </InfoBoxContent>
                </ZInfoBox>
            ) : (
                <ClosedBoxContainer>
                    <ClosedBox onClick={() => toggleHintBox(exerciseType)}>
                        <BulbIcon name="electric-light-bulb" fill="surface-grey-800" width="14" height="14" />
                        <InfoBoxTitle />
                    </ClosedBox>
                    <ClosedBoxTooltip content="Leggi come interagire con questo esercizio" top="4px" right="46px" />
                </ClosedBoxContainer>
            )}
        </>
    );
};

HintBox.propTypes = {
    label: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    isOpen: PropTypes.bool,
    exerciseType: PropTypes.string,
    toggleHintBox: PropTypes.func,
};

export default HintBox;
